import { HttpClient, HttpMethods } from "@planzone/services";
import { Discussion, Identifiable, Project } from "@planzone/dto";
import { LinkedList, LinkedResource } from "../linkers/types";
import { DiscussionSubjectTypes } from "../../dto/discussionSubjectTypes";

type ResourceType = "tasks" | "events" | "lists" | "milestones";

const resourceTypeToSubjectType: Record<ResourceType, DiscussionSubjectTypes> =
  {
    tasks: DiscussionSubjectTypes.TASK,
    events: DiscussionSubjectTypes.EVENT,
    lists: DiscussionSubjectTypes.LIST,
    milestones: DiscussionSubjectTypes.MILESTONE,
  };

function getListProject(httpClient: HttpClient) {
  return (uuid: string) =>
    httpClient.sendHttpRequest<Identifiable<Project>>({
      endpoint: `/activities/${uuid}/project`,
      method: HttpMethods.GET,
    });
}

function getEventProject(httpClient: HttpClient) {
  return (uuid: string) =>
    httpClient.sendHttpRequest<Identifiable<Project>>({
      endpoint: `/events/${uuid}/project`,
      method: HttpMethods.GET,
    });
}

function getList(httpClient: HttpClient) {
  return (type: ResourceType, uuid: string) =>
    httpClient.sendHttpRequest<LinkedList>({
      endpoint: `/${type}/${uuid}/activity`,
      method: HttpMethods.GET,
    });
}

function getProject(httpClient: HttpClient) {
  return (type: ResourceType, uuid: string) =>
    type === "lists"
      ? getListProject(httpClient)(uuid)
      : type === "events"
        ? getEventProject(httpClient)(uuid)
        : getList(httpClient)(type, uuid).then((list) =>
            getListProject(httpClient)(list.uuid),
          );
}

function createDiscussion(httpClient: HttpClient, effect: () => any): any {
  return (type: ResourceType) =>
    effect().then((response: any) =>
      getProject(httpClient)(type, response.uuid).then((project) =>
        httpClient
          .sendHttpRequest<LinkedResource<Identifiable<Discussion>>>({
            endpoint: "/discussions",
            method: HttpMethods.POST,
            data: {
              entityUuid: response.uuid,
              entityType: resourceTypeToSubjectType[type],
              project: `/projects/${project.uuid}`,
            },
          })
          .then((discussion) =>
            httpClient.sendHttpRequest({
              endpoint: `/${type === "lists" ? "activities" : type}/${
                response.uuid
              }`,
              method: HttpMethods.PATCH,
              data: { discussion: `discussions/${discussion.uuid}` },
            }),
          )
          .then(() => response),
      ),
    );
}

export { createDiscussion };
